import { PathingForm } from './../objects/pathingForm';
import { PathingKeys } from './../objects/pathingKeys';
import { FlightSerie } from './../objects/flightSerie';
import { FlightGenerationParams } from './../objects/flightGenerationParams';
import { List } from '../objects/list';
import { Errors } from '../objects/errors';
import { ManualFlight } from '../objects/manualFlight';
import { Currency } from '../../currency/objects/currency';
import { IataAirline } from '../../iata/objects/iataAirline';
import { IataAirport } from '../../iata/objects/iataAirport';
import { IataStation } from '../../iata/objects/iataStation';
import { IataAircraft } from '../../iata/objects/iataAircraft';
import { Preferences } from '../../profile/objects/preferences';
import { Segment, SegmentPeriod } from '../objects/segment';
import { ManualFlightEditStep } from '../objects/manualFlightState';
import { Column } from '../objects/column';
import { Circuit } from '../../circuit/objects/circuit';

export const ADD_PREFERENCES = 'MANUAL_FLIGHT_ADD_PREFERENCES';
export const ADD_SEGMENT = 'MANUAL_FLIGHT_ADD_SEGMENT';
export const PATHING_ADD_SEGMENT = 'MANUAL_FLIGHT_PATHING_ADD_SEGMENT';
export const DELETE_SEGMENT = 'MANUAL_FLIGHT_DELETE_SEGMENT';
export const PATHING_DELETE_SEGMENT = 'MANUAL_FLIGHT_PATHING_DELETE_SEGMENT';
export const MOVE_DOWN_COLUMN = 'MANUAL_FLIGHT_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'MANUAL_FLIGHT_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'MANUAL_FLIGHT_RESET_FILTERS';
export const RESET_MANUAL_FLIGHT = 'MANUAL_FLIGHT_RESET_MANUAL_FLIGHT';
export const SET_DELETE = 'MANUAL_FLIGHT_SET_DELETE';
export const SET_DELETE_PATHING = 'MANUAL_FLIGHT_SET_DELETE_PATHING';
export const SET_DUPLICATE = 'MANUAL_FLIGHT_SET_DUPLICATE';
export const SET_CREATE_SUCCESSIF = 'MANUAL_FLIGHT_SET_CREATE_SUCCESSIF';
export const SET_CREATE_STEP = 'MANUAL_FLIGHT_SET_CREATE_STEP';
export const GENERATE_FLIGHT_SERIES = 'MANUAL_FLIGHT_GENERATE_FLIGHT_SERIES';
export const UPDATE_FLIGHT_SERIES = 'MANUAL_FLIGHT_UPDATE_FLIGHT_SERIES';
export const REGROUP_FLIGHT_SERIES = 'MANUAL_FLIGHT_REGROUP_FLIGHT_SERIES';
export const SET_ERRORS = 'MANUAL_FLIGHT_SET_ERRORS';
export const SET_SEGMENTS_OUTBOUND_FIRST_DATE = 'MANUAL_FLIGHT_SET_SEGMENTS_OUTBOUND_FIRST_DATE';
export const SET_EXPORT_TYPE = 'MANUAL_FLIGHT_SET_EXPORT_TYPE';
export const SET_LIMIT = 'MANUAL_FLIGHT_SET_LIMIT';
export const SET_LIST = 'MANUAL_FLIGHT_SET_LIST';
export const SET_MANUAL_FLIGHT = 'MANUAL_FLIGHT_SET_MANUAL_FLIGHT';
export const SET_MANUAL_FLIGHT_ACTIVATE = 'MANUAL_FLIGHT_SET_MANUAL_FLIGHT_ACTIVATE';
export const SET_ORDER_BY = 'MANUAL_FLIGHT_SET_ORDER_BY';
export const SET_PAGE = 'MANUAL_FLIGHT_SET_PAGE';
export const SET_PREFERENCES = 'MANUAL_FLIGHT_SET_PREFERENCES';
export const SET_RUNNING = 'MANUAL_FLIGHT_SET_RUNNING';
export const SET_SCROLL_ID = 'MANUAL_FLIGHT_SET_SCROLL_ID';
export const SET_SEARCH = 'MANUAL_FLIGHT_SET_SEARCH';
export const TOGGLE_COLUMN = 'MANUAL_FLIGHT_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'MANUAL_FLIGHT_TOGGLE_CREATE';
export const TOGGLE_REFRESH_EDIT_FLIGHT_SERIES = 'MANUAL_FLIGHT_TOGGLE_REFRESH_EDIT_FLIGHT_SERIES';
export const TOGGLE_EDIT_FLIGHT_INFO = 'MANUAL_FLIGHT_TOGGLE_EDIT_FLIGHT_INFO';
export const TOGGLE_PATHING_EDIT_FLIGHT_INFO = 'MANUAL_FLIGHT_TOGGLE_PATHING_EDIT_FLIGHT_INFO';
export const TOGGLE_EDIT_DOMESTIC_SEGMENTS = 'MANUAL_FLIGHT_TOGGLE_EDIT_DOMESTIC_SEGMENTS';
export const TOGGLE_EDIT_OUTBOUND_SEGMENTS = 'MANUAL_FLIGHT_TOGGLE_EDIT_OUTBOUND_SEGMENTS';
export const TOGGLE_PATHING_EDIT_OUTBOUND_SEGMENTS = 'MANUAL_FLIGHT_TOGGLE_PATHING_EDIT_OUTBOUND_SEGMENTS';
export const TOGGLE_EDIT_RETURN_SEGMENTS = 'MANUAL_FLIGHT_TOGGLE_EDIT_RETURN_SEGMENTS';
export const TOGGLE_PATHING_EDIT_RETURN_SEGMENTS = 'MANUAL_FLIGHT_TOGGLE_PATHING_EDIT_RETURN_SEGMENTS';
export const TOGGLE_EXPORT = 'MANUAL_FLIGHT_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'MANUAL_FLIGHT_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'MANUAL_FLIGHT_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'MANUAL_FLIGHT_TOGGLE_REFRESH';
export const UPDATE_AIRLINE = 'MANUAL_FLIGHT_UPDATE_AIRLINE';
export const UPDATE_AIRLINE_PATHING = 'MANUAL_FLIGHT_UPDATE_AIRLINE_PATHING';
export const UPDATE_AIRLINE_PATHING_FORMS = 'MANUAL_FLIGHT_UPDATE_AIRLINE_PATHING_FORMS';
export const UPDATE_CURRENCY = 'MANUAL_FLIGHT_UPDATE_CURRENCY';
export const UPDATE_FILTER_ACTIVE = 'MANUAL_FLIGHT_UPDATE_FILTER_ACTIVE';
export const UPDATE_FILTER_AIRLINE = 'MANUAL_FLIGHT_UPDATE_FILTER_AIRLINE';
export const UPDATE_FILTER_AIRPORT = 'MANUAL_FLIGHT_UPDATE_FILTER_AIRPORT';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'MANUAL_FLIGHT_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'MANUAL_FLIGHT_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'MANUAL_FLIGHT_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_END_DATE_GTE = 'MANUAL_FLIGHT_UPDATE_FILTER_END_DATE_GTE';
export const UPDATE_FILTER_END_DATE_LTE = 'MANUAL_FLIGHT_UPDATE_FILTER_END_DATE_LTE';
export const UPDATE_FILTER_LAST_AUTHOR = 'MANUAL_FLIGHT_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'MANUAL_FLIGHT_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'MANUAL_FLIGHT_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'MANUAL_FLIGHT_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'MANUAL_FLIGHT_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FILTER_PNR_NUMBER = 'MANUAL_FLIGHT_UPDATE_FILTER_PNR_NUMBER';
export const UPDATE_FILTER_START_DATE_GTE = 'MANUAL_FLIGHT_UPDATE_FILTER_START_DATE_GTE';
export const UPDATE_FILTER_START_DATE_LTE = 'MANUAL_FLIGHT_UPDATE_FILTER_START_DATE_LTE';
export const UPDATE_PNR_NUMBER = 'MANUAL_FLIGHT_UPDATE_PNR_NUMBER';
export const UPDATE_PRICE_ADULT = 'MANUAL_FLIGHT_UPDATE_PRICE_ADULT';
export const UPDATE_PRICE_CHILD = 'MANUAL_FLIGHT_UPDATE_PRICE_CHILD';
export const UPDATE_PRICE_INFANT = 'MANUAL_FLIGHT_UPDATE_PRICE_INFANT';
export const UPDATE_PURCHASE_PRICE_ADULT = 'MANUAL_FLIGHT_UPDATE_PURCHASE_PRICE_ADULT';
export const UPDATE_PURCHASE_PRICE_CHILD = 'MANUAL_FLIGHT_UPDATE_PURCHASE_PRICE_CHILD';
export const UPDATE_PURCHASE_PRICE_INFANT = 'MANUAL_FLIGHT_UPDATE_PURCHASE_PRICE_INFANT';
export const UPDATE_SEGMENT_AIRCRAFT = 'MANUAL_FLIGHT_UPDATE_SEGMENT_AIRCRAFT';
export const UPDATE_PATHING_SEGMENT_PROPERTY = 'MANUAL_FLIGHT_UPDATE_PATHING_SEGMENT_PROPERTY';
export const UPDATE_PATHING_FORMS_SEGMENT_PROPERTY = 'MANUAL_FLIGHT_UPDATE_PATHING_FORMS_SEGMENT_PROPERTY';
export const UPDATE_CIRCUIT_LIST = 'MANUAL_FLIGHT_UPDATE_CIRCCUIT_LIST';
export const UPDATE_TARGET = 'MANUAL_FLIGHT_UPDATE_TARGET';
export const UPDATE_SEGMENT_AIRLINE = 'MANUAL_FLIGHT_UPDATE_SEGMENT_AIRLINE';
export const UPDATE_SEGMENT_BAG_UNIT = 'MANUAL_FLIGHT_UPDATE_SEGMENT_BAG_UNIT';
export const UPDATE_SEGMENT_CABIN_CLASS = 'MANUAL_FLIGHT_UPDATE_SEGMENT_CABIN_CLASS';
export const UPDATE_SEGMENT_CABIN_CLASS_CODE = 'MANUAL_FLIGHT_UPDATE_SEGMENT_CABIN_CLASS_CODE';
export const UPDATE_SEGMENT_CARRY_BAG_NUMBER = 'MANUAL_FLIGHT_UPDATE_SEGMENT_CARRY_BAG_NUMBER';
export const UPDATE_SEGMENT_CARRY_BAG_WEIGHT = 'MANUAL_FLIGHT_UPDATE_SEGMENT_CARRY_BAG_WEIGHT';
export const UPDATE_SEGMENT_CHECKED_BAG_NUMBER = 'MANUAL_FLIGHT_UPDATE_SEGMENT_CHECKED_BAG_NUMBER';
export const UPDATE_SEGMENT_CHECKED_BAG_WEIGHT = 'MANUAL_FLIGHT_UPDATE_SEGMENT_CHECKED_BAG_WEIGHT';
export const UPDATE_SEGMENT_DESTINATION_AIRPORT = 'MANUAL_FLIGHT_UPDATE_SEGMENT_DESTINATION_AIRPORT';
export const UPDATE_SEGMENT_DESTINATION_STATION = 'MANUAL_FLIGHT_UPDATE_SEGMENT_DESTINATION_STATION';
export const UPDATE_SEGMENT_DESTINATION_TERMINAL = 'MANUAL_FLIGHT_UPDATE_SEGMENT_DESTINATION_TERMINAL';
export const UPDATE_SEGMENT_DURATION_HOUR = 'MANUAL_FLIGHT_UPDATE_SEGMENT_DURATION_HOUR';
export const UPDATE_SEGMENT_DURATION_MINUTE = 'MANUAL_FLIGHT_UPDATE_SEGMENT_DURATION_MINUTE';
export const UPDATE_SEGMENT_END_DATE = 'MANUAL_FLIGHT_UPDATE_SEGMENT_END_DATE';
export const UPDATE_SEGMENT_END_DATE_HOUR = 'MANUAL_FLIGHT_UPDATE_SEGMENT_END_DATE_HOUR';
export const UPDATE_SEGMENT_END_DATE_MINUTE = 'MANUAL_FLIGHT_UPDATE_SEGMENT_END_DATE_MINUTE';
export const UPDATE_SEGMENT_FLIGHT_NUMBER = 'MANUAL_FLIGHT_UPDATE_SEGMENT_FLIGHT_NUMBER';
export const UPDATE_SEGMENT_IS_NIGHTLY = 'MANUAL_FLIGHT_UPDATE_SEGMENT_IS_NIGHTLY';
export const UPDATE_SEGMENT_MEAL_INCLUDED = 'MANUAL_FLIGHT_UPDATE_SEGMENT_MEAL_INCLUDED';
export const UPDATE_SEGMENT_ORIGIN_AIRPORT = 'MANUAL_FLIGHT_UPDATE_SEGMENT_ORIGIN_AIRPORT';
export const UPDATE_SEGMENT_ORIGIN_STATION = 'MANUAL_FLIGHT_UPDATE_SEGMENT_ORIGIN_STATION';
export const UPDATE_SEGMENT_ORIGIN_TERMINAL = 'MANUAL_FLIGHT_UPDATE_SEGMENT_ORIGIN_TERMINAL';
export const UPDATE_SEGMENT_START_DATE = 'MANUAL_FLIGHT_UPDATE_SEGMENT_START_DATE';
export const UPDATE_SEGMENT_START_DATE_HOUR = 'MANUAL_FLIGHT_UPDATE_SEGMENT_START_DATE_HOUR';
export const UPDATE_SEGMENT_START_DATE_MINUTE = 'MANUAL_FLIGHT_UPDATE_SEGMENT_START_DATE_MINUTE';
export const UPDATE_TAXES_ADULT = 'MANUAL_FLIGHT_UPDATE_TAXES_ADULT';
export const UPDATE_TAXES_CHILD = 'MANUAL_FLIGHT_UPDATE_TAXES_CHILD';
export const UPDATE_TAXES_INFANT = 'MANUAL_FLIGHT_UPDATE_TAXES_INFANT';
export const UPDATE_TOTAL_STOCK = 'MANUAL_FLIGHT_UPDATE_TOTAL_STOCK';
export const UPDATE_SEGMENT_PERIOD_FIELD = 'MANUAL_FLIGHT_UPDATE_SEGMENT_PERIOD_FIELD';
export const UPDATE_FLIGHTS_GENERATIONS_PARAMS = 'MANUAL_FLIGHT_UPDATE_FLIGHTS_GENERATIONS_PARAMS';
export const ADD_FLIGHTS_GENERATIONS_PARAMS = 'MANUAL_FLIGHT_ADD_FLIGHTS_GENERATIONS_PARAMS';
export const DELETE_FLIGHTS_GENERATIONS_PARAMS = 'MANUAL_FLIGHT_DELETE_FLIGHTS_GENERATIONS_PARAMS';
export const UPDATE_RETROCESSION_DATE_DATE = 'MANUAL_FLIGHT_UPDATE_RETROCESSION_DATE_DATE';
export const UPDATE_RETROCESSION_DATE_NUMBER = 'MANUAL_FLIGHT_UPDATE_RETROCESSION_DATE_NUMBER';
export const UPDATE_RETROCESSION_DATE_TYPE = 'MANUAL_FLIGHT_UPDATE_RETROCESSION_DATE_TYPE';
export const UPDATE_PATHING_FIELD = 'MANUAL_FLIGHT_UPDATE_PATHING_FIELD';
export const ADD_PRE_POST_PATHING = 'MANUAL_FLIGHT_ADD_PRE_POST_PATHING';
export const SET_FROM_SERIES = 'MANUAL_FLIGHT_SET_FROM_SERIES';
export const SET_EDIT_STEP ='MANUAL_FLIGHT_SET_EDIT_STEP';
export const SET_IS_FLIGHT_SERIES_OPEN ='MANUAL_FLIGHT_SET_IS_FLIGHT_SERIES_OPEN';
export const SET_LOADING_PATHINGS ='MANUAL_FLIGHT_SET_LOADING_PATHINGS';
export const SET_REFRESH_PATHINGS ='MANUAL_FLIGHT_SET_REFRESH_PATHINGS';
export const SET_PATHINGS ='MANUAL_FLIGHT_SET_PATHINGS';
export const SET_PATHING ='MANUAL_FLIGHT_SET_PATHING';
export const SET_COLUMNS = 'MANUAL_FLIGHT_SET_COLUMNS';
export const ADD_PATHING_FORM = 'MANUAL_FLIGHT_ADD_PATHING_FORM';
export const UPDATE_PATHING_FORM = 'MANUAL_FLIGHT_UPDATE_PATHING_FORM';
export const DELETE_PATHING_FORM = 'MANUAL_FLIGHT_SET_COLUMNS_FORM';
export const ADD_PATHING_FORMS_SEGMENT = 'MANUAL_FLIGHT_ADD_PATHING_FORMS_SEGMENT';
export const DELETE_PATHING_FORMS_SEGMENT = 'MANUAL_FLIGHT_DELETE_PATHING_FORMS_SEGMENT';


interface UpdateTarget {
    type: typeof UPDATE_TARGET,
    payload: "ANY" | "CIRCUIT" | "TAILOR_MADE"
}
interface UpdateCircuitList {
    type: typeof UPDATE_CIRCUIT_LIST,
    payload: Circuit[]
}
interface AddPathingFormAction {
    type: typeof ADD_PATHING_FORM,
}
interface DeletePathingFormAction {
    type: typeof DELETE_PATHING_FORM,
    payload: number
}
interface UpdatePathingFormAction {
    type: typeof UPDATE_PATHING_FORM,
    payload: {
        pathing_form_index: number,
        value: any,
        key: keyof PathingForm
    }
}
interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}
interface SetLoadingPathingsAction {
    type: typeof SET_LOADING_PATHINGS,
    payload: boolean
}interface SetRefreshPathingsAction {
    type: typeof SET_REFRESH_PATHINGS
}interface SetSetPathingsAction {
    type: typeof SET_PATHINGS,
    payload: ManualFlight[]
}interface SetSetPathingAction {
    type: typeof SET_PATHING,
    payload: ManualFlight | null
}
interface SetIsFlightSeriesOpenAction {
    type: typeof SET_IS_FLIGHT_SERIES_OPEN,
    payload: boolean
}
interface SetFromSeriesAction {
    type: typeof SET_FROM_SERIES,
    payload: boolean
}
interface SetEditStep {
    type: typeof SET_EDIT_STEP,
    payload: ManualFlightEditStep
}
interface AddPrePostPathingAction {
    type: typeof ADD_PRE_POST_PATHING,
    payload: boolean
}
interface UpdatePathingFieldAction {
    type: typeof UPDATE_PATHING_FIELD,
    payload: {
        field: PathingKeys,
        value: any
    }
}
interface UpdateRetrocesssionDateTypeAction {
    type: typeof UPDATE_RETROCESSION_DATE_TYPE,
    payload: 'DATE' | 'NUMBER'
}
interface UpdateRetrocessionDateDateAction {
    type: typeof UPDATE_RETROCESSION_DATE_DATE,
    payload: null | Date
}
interface UpdateRetrocessionDateNumberAction {
    type: typeof UPDATE_RETROCESSION_DATE_NUMBER,
    payload: null | number | string
}

interface UpdateFlightGenerationParamsAction {
    type: typeof UPDATE_FLIGHTS_GENERATIONS_PARAMS,
    payload: {
        index: number,
        value: any,
        field: keyof FlightGenerationParams
    }
}
interface AddFlightGenerationParamsAction {
    type: typeof ADD_FLIGHTS_GENERATIONS_PARAMS,
    payload: {
        is_one_day: boolean
    }
}
interface DeleteFlightGenerationParamsAction {
    type: typeof DELETE_FLIGHTS_GENERATIONS_PARAMS,
    payload: {
        index: number
    }
}
interface UpdateSegmentPeriodFieldAction {
    type: typeof UPDATE_SEGMENT_PERIOD_FIELD,
    payload: {field: keyof SegmentPeriod, value: any, origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN', domestic_index: number | undefined, segment_index: number, period_index: number}
}
interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface AddSegmentAction {
    type: typeof ADD_SEGMENT,
    payload: {
        type: 'OUTBOUND'| 'DOMESTIC' | 'RETURN',
        index: number | undefined
    }
}
interface AddPathingFormsSegmentAction {
    type: typeof ADD_PATHING_FORMS_SEGMENT,
    payload: {
        type: 'OUTBOUND' | 'RETURN',
        pathing_index: number,
    }
}
interface PathingAddSegmentAction {
    type: typeof PATHING_ADD_SEGMENT,
    payload: {
        type: 'OUTBOUND'  | 'RETURN',
        index: number | undefined
    }
}
interface DeleteSegmentAction {
    type: typeof DELETE_SEGMENT,
    payload: {
        type: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        index: number,
        domestic_index: number | undefined
    }
}
interface PathingDeleteSegmentAction {
    type: typeof PATHING_DELETE_SEGMENT,
    payload: {
        type: 'OUTBOUND' | 'RETURN',
        index: number,
        domestic_index: number | undefined
    }
}

interface DeletePathingFormsSegmentAction {
    type: typeof DELETE_PATHING_FORMS_SEGMENT,
    payload: {
        type: 'OUTBOUND' | 'RETURN',
        index: number,
        pathing_index: number
    }
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface ResetManualFlightAction {
    type: typeof RESET_MANUAL_FLIGHT
}

interface SetDeleteAction {
    type: typeof SET_DELETE,
    payload: ManualFlight | null | false
}
interface SetDeletePathingAction {
    type: typeof SET_DELETE_PATHING,
    payload: ManualFlight | null
}

interface SetDuplicateAction {
    type: typeof SET_DUPLICATE,
    payload: ManualFlight
}
interface SetCreateSuccessifAction {
    type: typeof SET_CREATE_SUCCESSIF,
    payload: boolean
}
interface SetCreateStepAction {
    type: typeof SET_CREATE_STEP,
    payload: number
}
interface GenerateFlightSeriesAction {
    type: typeof GENERATE_FLIGHT_SERIES,
}
interface UpdateFlightSeriesAction {
    type: typeof UPDATE_FLIGHT_SERIES,
    payload: FlightSerie[]
}
interface RegroupFlightSeriesAction {
    type: typeof REGROUP_FLIGHT_SERIES,
    payload: ManualFlight[]
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Errors[]
}
interface SetSegmentsOutboundFirstDateAction {
    type: typeof SET_SEGMENTS_OUTBOUND_FIRST_DATE,
    payload: Date | null
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetManualFlightAction {
    type: typeof SET_MANUAL_FLIGHT,
    payload: ManualFlight
}

interface SetManualFlightActivateAction {
    type: typeof SET_MANUAL_FLIGHT_ACTIVATE,
    payload: null | ManualFlight | false
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetScrollIdAction {
    type: typeof SET_SCROLL_ID,
    payload: null
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleCreateAction {
    type: typeof TOGGLE_CREATE
}
interface ToggleRefreshEditFlightSeriesAction {
    type: typeof TOGGLE_REFRESH_EDIT_FLIGHT_SERIES
}

interface ToggleEditFlightInfoAction {
    type: typeof TOGGLE_EDIT_FLIGHT_INFO
}
interface TogglePathingEditFlightInfoAction {
    type: typeof TOGGLE_PATHING_EDIT_FLIGHT_INFO
}

interface ToggleEditDomesticSegmentsAction {
    type: typeof TOGGLE_EDIT_DOMESTIC_SEGMENTS
}

interface ToggleEditOutboundSegmentsAction {
    type: typeof TOGGLE_EDIT_OUTBOUND_SEGMENTS
}
interface ToggleEditPathingOutboundSegmentsAction {
    type: typeof TOGGLE_PATHING_EDIT_OUTBOUND_SEGMENTS
}

interface ToggleEditReturnSegmentsAction {
    type: typeof TOGGLE_EDIT_RETURN_SEGMENTS
}
interface TogglePathingEditReturnSegmentsAction {
    type: typeof TOGGLE_PATHING_EDIT_RETURN_SEGMENTS
}
interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateAirlineAction {
    type: typeof UPDATE_AIRLINE,
    payload: IataAirline | null
}
interface UpdateAirlinePathingAction {
    type: typeof UPDATE_AIRLINE_PATHING,
    payload: IataAirline | null
}
interface UpdateAirlinePathingFormsAction {
    type: typeof UPDATE_AIRLINE_PATHING_FORMS,
    payload: {
        value: IataAirline | null,
        pathing_index: number
    }
}

interface UpdateCurrencyAction {
    type: typeof UPDATE_CURRENCY,
    payload: null | Currency
}

interface UpdateFilterActiveAction {
    type: typeof UPDATE_FILTER_ACTIVE,
    payload: 'ACTIVATED' | 'DEACTIVATED' | 'BOTH'
}

interface UpdateFilterAirlineAction {
    type: typeof UPDATE_FILTER_AIRLINE,
    payload: null | IataAirline
}

interface UpdateFilterAirportAction {
    type: typeof UPDATE_FILTER_AIRPORT,
    payload: null | IataAirport
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterEndDateGteAction {
    type: typeof UPDATE_FILTER_END_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterEndDateLteAction {
    type: typeof UPDATE_FILTER_END_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION' | 'START_DATE' | 'END_DATE'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFilterPnrNumberAction {
    type: typeof UPDATE_FILTER_PNR_NUMBER,
    payload: string
}

interface UpdateFilterStartDateGteAction {
    type: typeof UPDATE_FILTER_START_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterStartDateLteAction {
    type: typeof UPDATE_FILTER_START_DATE_LTE,
    payload: Date | null
}

interface UpdatePnrNumberAction {
    type: typeof UPDATE_PNR_NUMBER,
    payload: string
}

interface UpdatePriceAdultAction {
    type: typeof UPDATE_PRICE_ADULT,
    payload: string | number
}

interface UpdatePriceChildAction {
    type: typeof UPDATE_PRICE_CHILD,
    payload: string | number
}

interface UpdatePriceInfantAction {
    type: typeof UPDATE_PRICE_INFANT,
    payload: string | number
}

interface UpdatePurchasePriceAdultAction {
    type: typeof UPDATE_PURCHASE_PRICE_ADULT,
    payload: string | number
}

interface UpdatePurchasePriceChildAction {
    type: typeof UPDATE_PURCHASE_PRICE_CHILD,
    payload: string | number
}

interface UpdatePurchasePriceInfantAction {
    type: typeof UPDATE_PURCHASE_PRICE_INFANT,
    payload: string | number
}

interface UpdateSegmentAircraftAction {
    type: typeof UPDATE_SEGMENT_AIRCRAFT,
    payload: {
        value: null | IataAircraft,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}
interface UpdatePathingSegmentPropertyAction {
    type: typeof UPDATE_PATHING_SEGMENT_PROPERTY,
    payload: {
        value: any,
        origin: 'OUTBOUND' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number,
        key: keyof Segment
    }
}

interface UpdatePathingFormsSegmentPropertyAction {
    type: typeof UPDATE_PATHING_FORMS_SEGMENT_PROPERTY,
    payload: {
        pathing_index: number,
        value: any,
        origin: 'OUTBOUND' | 'RETURN',
        segment_index: number,
        key: keyof Segment
    }
}

interface UpdateSegmentAirlineAction {
    type: typeof UPDATE_SEGMENT_AIRLINE,
    payload: {
        value: null | IataAirline,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentBagUnitAction {
    type: typeof UPDATE_SEGMENT_BAG_UNIT,
    payload: {
        value: 'KG' | 'LB',
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentCabinClassAction {
    type: typeof UPDATE_SEGMENT_CABIN_CLASS,
    payload: {
        value: 'economy' | 'premium_economy' | 'business' | 'first',
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentCabinClassCodeAction {
    type: typeof UPDATE_SEGMENT_CABIN_CLASS_CODE,
    payload: {
        value: string,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentCarryBagNumberAction {
    type: typeof UPDATE_SEGMENT_CARRY_BAG_NUMBER,
    payload: {
        value: string | number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentCarryBagWeightAction {
    type: typeof UPDATE_SEGMENT_CARRY_BAG_WEIGHT,
    payload: {
        value: string | number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentCheckedBagNumberAction {
    type: typeof UPDATE_SEGMENT_CHECKED_BAG_NUMBER,
    payload: {
        value: string | number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentCheckedBagWeightAction {
    type: typeof UPDATE_SEGMENT_CHECKED_BAG_WEIGHT,
    payload: {
        value: string | number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentDestinationAirportAction {
    type: typeof UPDATE_SEGMENT_DESTINATION_AIRPORT,
    payload: {
        value: null | IataAirport,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentDestinationStationAction {
    type: typeof UPDATE_SEGMENT_DESTINATION_STATION,
    payload: {
        value: null | IataStation,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentDestinationTerminalAction {
    type: typeof UPDATE_SEGMENT_DESTINATION_TERMINAL,
    payload: {
        value: string,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentDurationHourAction {
    type: typeof UPDATE_SEGMENT_DURATION_HOUR,
    payload: {
        value: number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentDurationMinuteAction {
    type: typeof UPDATE_SEGMENT_DURATION_MINUTE,
    payload: {
        value: number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentEndDateAction {
    type: typeof UPDATE_SEGMENT_END_DATE,
    payload: {
        value: null | Date,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentEndDateHourAction {
    type: typeof UPDATE_SEGMENT_END_DATE_HOUR,
    payload: {
        value: number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentEndDateMinuteAction {
    type: typeof UPDATE_SEGMENT_END_DATE_MINUTE,
    payload: {
        value: number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentFlightNumberAction {
    type: typeof UPDATE_SEGMENT_FLIGHT_NUMBER,
    payload: {
        value: string,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentIsNightlyAction {
    type: typeof UPDATE_SEGMENT_IS_NIGHTLY,
    payload: {
        value: boolean,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentMealIncludedAction {
    type: typeof UPDATE_SEGMENT_MEAL_INCLUDED,
    payload: {
        value: boolean,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentOriginAirportAction {
    type: typeof UPDATE_SEGMENT_ORIGIN_AIRPORT,
    payload: {
        value: null | IataAirport,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentOriginStationAction {
    type: typeof UPDATE_SEGMENT_ORIGIN_STATION,
    payload: {
        value: null | IataStation,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentOriginTerminalAction {
    type: typeof UPDATE_SEGMENT_ORIGIN_TERMINAL,
    payload: {
        value: string,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentStartDateAction {
    type: typeof UPDATE_SEGMENT_START_DATE,
    payload: {
        value: null | Date,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentStartDateHourAction {
    type: typeof UPDATE_SEGMENT_START_DATE_HOUR,
    payload: {
        value: number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateSegmentStartDateMinuteAction {
    type: typeof UPDATE_SEGMENT_START_DATE_MINUTE,
    payload: {
        value: number,
        origin: 'OUTBOUND' | 'DOMESTIC' | 'RETURN',
        domestic_index: number | undefined,
        segment_index: number
    }
}

interface UpdateTaxesAdultAction {
    type: typeof UPDATE_TAXES_ADULT,
    payload: string | number
}

interface UpdateTaxesChildAction {
    type: typeof UPDATE_TAXES_CHILD,
    payload: string | number
}

interface UpdateTaxesInfantAction {
    type: typeof UPDATE_TAXES_INFANT,
    payload: string | number
}

interface UpdateTotalStockAction {
    type: typeof UPDATE_TOTAL_STOCK,
    payload: string | number
}

export type ManualFlightActionTypes =
    UpdateCircuitList |
    UpdateTarget |
    UpdatePathingFormAction |
    AddPathingFormAction |
    DeletePathingFormAction |
    SetColumnsAction |
    SetLoadingPathingsAction |
    SetRefreshPathingsAction |
    SetSetPathingsAction |
    SetSetPathingAction |
    SetEditStep |
    SetIsFlightSeriesOpenAction |
    SetFromSeriesAction |
    AddPrePostPathingAction |
    UpdatePathingFieldAction |
    UpdateFlightGenerationParamsAction |
    AddFlightGenerationParamsAction |
    DeleteFlightGenerationParamsAction |
    RegroupFlightSeriesAction |
    UpdateFlightSeriesAction |
    GenerateFlightSeriesAction |
    UpdateSegmentPeriodFieldAction |
    UpdateRetrocessionDateDateAction |
    UpdateRetrocesssionDateTypeAction |
    UpdateRetrocessionDateNumberAction |
    AddPreferencesAction |
    AddSegmentAction |
    AddPathingFormsSegmentAction |
    PathingAddSegmentAction |
    DeleteSegmentAction |
    PathingDeleteSegmentAction |
    DeletePathingFormsSegmentAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    ResetManualFlightAction |
    SetDeletePathingAction |
    SetDeleteAction |
    SetDuplicateAction |
    SetCreateSuccessifAction |
    SetCreateStepAction |
    SetErrorsAction |
    SetSegmentsOutboundFirstDateAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetManualFlightAction |
    SetManualFlightActivateAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetRunningAction |
    SetScrollIdAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleCreateAction |
    ToggleRefreshEditFlightSeriesAction |
    ToggleEditFlightInfoAction |
    TogglePathingEditFlightInfoAction |
    ToggleEditDomesticSegmentsAction |
    ToggleEditOutboundSegmentsAction |
    ToggleEditPathingOutboundSegmentsAction |
    ToggleEditReturnSegmentsAction |
    TogglePathingEditReturnSegmentsAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleRefreshAction |
    UpdateAirlineAction |
    UpdateAirlinePathingAction |
    UpdateAirlinePathingFormsAction |
    UpdateCurrencyAction |
    UpdateFilterActiveAction |
    UpdateFilterAirlineAction |
    UpdateFilterAirportAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterEndDateGteAction |
    UpdateFilterEndDateLteAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFilterPnrNumberAction |
    UpdateFilterStartDateGteAction |
    UpdateFilterStartDateLteAction |
    UpdatePnrNumberAction |
    UpdatePriceAdultAction |
    UpdatePriceChildAction |
    UpdatePriceInfantAction |
    UpdatePurchasePriceAdultAction |
    UpdatePurchasePriceChildAction |
    UpdatePurchasePriceInfantAction |
    UpdateSegmentAircraftAction |
    UpdatePathingSegmentPropertyAction |
    UpdatePathingFormsSegmentPropertyAction |
    UpdateSegmentAirlineAction |
    UpdateSegmentBagUnitAction |
    UpdateSegmentCabinClassAction |
    UpdateSegmentCabinClassCodeAction |
    UpdateSegmentCarryBagNumberAction |
    UpdateSegmentCarryBagWeightAction |
    UpdateSegmentCheckedBagNumberAction |
    UpdateSegmentCheckedBagWeightAction |
    UpdateSegmentDestinationAirportAction |
    UpdateSegmentDestinationStationAction |
    UpdateSegmentDestinationTerminalAction |
    UpdateSegmentDurationHourAction |
    UpdateSegmentDurationMinuteAction |
    UpdateSegmentEndDateAction |
    UpdateSegmentEndDateHourAction |
    UpdateSegmentEndDateMinuteAction |
    UpdateSegmentFlightNumberAction |
    UpdateSegmentIsNightlyAction |
    UpdateSegmentMealIncludedAction |
    UpdateSegmentOriginAirportAction |
    UpdateSegmentOriginStationAction |
    UpdateSegmentOriginTerminalAction |
    UpdateSegmentStartDateAction |
    UpdateSegmentStartDateHourAction |
    UpdateSegmentStartDateMinuteAction |
    UpdateTaxesAdultAction |
    UpdateTaxesChildAction |
    UpdateTaxesInfantAction |
    UpdateTotalStockAction;